var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.personCurrent)?_c('div',{staticClass:"acc-page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"acc-dropzone col-md-12"},[_c('Dropzone')],1)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4310054","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Upload.vue
// module id = Xtxk
// module chunks = 0